import { Component, OnInit} from '@angular/core';


@Component({
    selector: 'app-footer',
    template: `<div class="rights-column"><p>© {{current_date}}. All rights reserved.</p></div>`,
    styles: [`
    
    `],
    standalone: false
})

export class AppFooterComponent implements OnInit {

    current_date = new Date().getFullYear()
    constructor() { }
    ngOnInit(): void {
    }

}